<div [class]="skinName">
  @if (deviceType) {
    <div class="device-info">
      <div>
        <img class="device-backbone" src="{{deviceType.device_backbone_img}}" alt="Smart TVs">
        <div class="device-name">{{deviceType.device_type}}</div>
        <div class="device-desc">{{deviceType.device_description}}</div>
      </div>
      <div class="device-img">
        @if (deviceType.device_logo1[0]) {
          <div class="device-logo">
            @if (deviceType.device_logo1) {
              <img (click)="gotoSection(deviceType.device_logo1[1])" class="first-img" src="{{deviceType.device_logo1[0]}}" alt="">
            }
          </div>
        }
        @if (deviceType.device_logo2[0]) {
          <div class="device-logo">
            @if (deviceType.device_logo2) {
              <img (click)="gotoSection(deviceType.device_logo2[1])" class="second-img" src="{{deviceType.device_logo2[0]}}" alt="">
            }
          </div>
        }
        @if (deviceType.device_logo3[0]) {
          <div class="device-logo">
            @if (deviceType.device_logo3) {
              <img (click)="gotoSection(deviceType.device_logo3[1])" class="first-img" src="{{deviceType.device_logo3[0]}}" alt="">
            }
          </div>
        }
        @if (deviceType.device_logo4[0]) {
          <div class="device-logo">
            @if (deviceType.device_logo4) {
              <img (click)="gotoSection(deviceType.device_logo4[1])" class="second-img" src="{{deviceType.device_logo4[0]}}" alt="">
            }
          </div>
        }
      </div>
    </div>
  }

  <div class="device-content">
    @for (device of samrtTVInfo; track device; let i = $index) {
      <details id="{{device.type_slug}}" (click)="update($event, device)">
        <summary>{{device.device_name}}</summary>
        <div id="device-summary" class="mt-4 mb-1">
          <div class="device-intro">
            <div class="device-head">
              <p class="device-detail-para">{{device.device_desc}}</p>
              <p class="device-detail-para detail-para">{{device.device_para}}</p>
            </div>
            <img src="{{device.device_logo}}" alt="brand">
          </div>
          <!-- <div class="detail-main-img">
          <iframe [src]='getVideoURL(device.device_main_img)' frameborder="0" allowfullscreen width="560" height="314"></iframe>
        </div> -->
        <div>
          @for (step of device.device_steps; track step; let i = $index) {
            <div class="device-steps-block">
              <img src="{{step.stepImg+device.image_name+'/'+device.image_type+'_'+(i+1)+image_format}}" [alt]="device.image_name">
              <p><span>{{i+1}} &nbsp;-&nbsp;</span>
              <read-more  [text]="step.stespDesc" [maxLength]="250"></read-more>
            </p>
          </div>
        }
      </div>
    </div>
  </details>
}
</div>

</div>